<template>
  <!-- 注册界面 -->
  <div id="Register">
    <!-- 注册界面 -->
    <div class="header">
      <div>
        <a
          title="登录海星云云游戏平台,海星云,云游戏,海星云云平台,海星云云游戏"
          class="fl logo"
        >
          <img
            draggable="false"
            src="../../static/images/logo/logo1.png"
            alt="海星云,云游戏,海星云云平台,海星云云游戏"
          />
        </a>
      </div>
      <p>海星云云游戏平台绑定手机号</p>
    </div>
    <div>
      <div class="signIn">
        <!-- 手机号 -->
        <div class="from">
          <div class="input">
            <p class="fl">手机号码</p>
            <div>
              <input
                type="text"
                class="inputm fl"
                :class="[phone == false ? 'inputm' : 'inputh']"
                placeholder="请输入手机号码"
                @blur="phonea"
                v-model="shuru.phone"
              />
              <span>{{ cuowuspan.phone }}</span>
            </div>
          </div>

          <!-- 验证码 -->
          <div class="input">
            <p class="fl">验证码</p>
            <div>
              <input
                type="text"
                class="inputm fl"
                style="width:120px"
                :class="[Verification == false ? 'inputm' : 'inputh']"
                placeholder="请输入六位验证码"
                @blur="Verificationa"
                v-model="shuru.Verification"
              />
              <button
                style="
                                border:1px solid #dfdfdf;
                                width:100px;
                                height:40px;
                                background:#356DED;
                                color:#dfdfdf;
                                border-radius:5px;
                            "
                :disabled="disabled"
                @click="send"
              >
                {{ sends }}
              </button>
              <span>{{ cuowuspan.Verification }}</span>
            </div>
          </div>

          <!-- 密码 -->
          <div class="input" v-show="password_show">
            <p class="fl">密码</p>
            <div>
              <input
                type="password"
                class="inputm fl"
                :class="[pass == false ? 'inputm' : 'inputh']"
                placeholder="请输入数字字母8~25位密码"
                @blur="passa"
                v-model="shuru.pass"
                autocomplete="new-password"
              />
              <span>{{ cuowuspan.pass }}</span>
            </div>
          </div>
        </div>

        <div class="Registerbtn">
          <a
            :class="[checked == true ? 'Registerbtnl' : 'Registerbtnm']"
            @click="Register"
            >绑定</a
          >
          <!-- <p>实名认证一小时内可认证三次，一天内可认证五次，认证不通过则无法注册。</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: '注册海星云,云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      // 滑块参数
      nc_token: '',
      csessionid: '',
      sig: '',
      access_token: '',
      open_id: '',
      // 发送验证按按钮
      sendstime: 60,
      disabled: false,
      sends: '获取验证码',
      checked: false,

      shifou: false,
      password_show: false,
      img: '',
      Return: './../../static/images/icon/Return.png',
      why: false,
      zhucexieyi: false,
      // 输入的数据
      shuru: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        // name:'',
        // idcard:'',
        invitation: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: '',
        pass: '',
        password: '',
        email: '',
        // name:'',
        // idcard:'',
        invitation: ''
      },
      // 标识符
      phone: true,
      Verification: true,
      pass: true,

      sceneaa: ''
    }
  },
  methods: {
    send () {
      if (this.shuru.phone == '') {
        this.cuowuspan.phone = '请填写手机号'
        this.phone = true
        return false
      } else {
        this.http.send(this.shuru.phone, this.nc_token, this.csessionid, this.sig).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'ok') {
              this.$message({
                message: '验证码已发送到您的手机，请注意查看',
                type: 'success'
              })
              var that = this
              var resend = setInterval(function () {
                that.sendstime--
                if (that.sendstime > 0) {
                  that.sends = that.sendstime + 's后重新获取'
                  that.disabled = true
                } else {
                  clearInterval(resend)
                  that.sends = '获取验证码'
                  that.sendstime = 60
                  that.disabled = false
                }
              }, 1000)
            }
          } else if (res.data.code == 400) {
            if (res.data.message == 'failed,unable to get data') {
              this.$message.error('不能获取到数据')
            } else if (res.data.message == 'failed,user phone invalid') {
              this.$message.error('手机号无效')
            } else if (res.data.message == 'failed,afs authenticate invalid') {
              this.$message.error('滑块验证失败')
            }
          } else if (res.data.code == 500) {
            if (res.data.message == 'failed,please retry!') {
              this.$message.error('验证码发送过于频繁，请稍后再试。，请重试！')
            }
          }
        })
      }
    },
    // 跳转使用手册详情页
    anzhuo () {
      this.$router.push({
        path: './manual_details',
        query: {
          manual: 12
        }
      })
    },
    ppcc () {
      this.$router.push({
        path: './manual_details',
        query: {
          manual: 11
        }
      })
    },

    fanhui () {
      this.shifou = false
      this.$router.push('./Home')
    },
    shiming () {
      this.shifou = false
      this.$router.push('./SignIn')
    },
    Returngo () {
      this.$router.push('./Home')
    },
    Returnasdf () {
      this.Return = './../../static/images/icon/Return1.png'
    },
    Returna () {
      this.Return = './../../static/images/icon/Return.png'
    },
    whya () {
      this.why = true
    },
    whyb () {
      this.why = false
    },
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          return false
        }
        this.http.yzpho(this.shuru.phone).then(res => {
          if (res.data.code == 200) {
            if (res.data.message == 'true') {
              this.password_show = false
              return false
            } else {
              this.password_show = true
              return false
            }
          } else if (res.data.code == 500) {
            this.$notify({
              title: '请联系管理员咨询',
              type: 'warning'
            })
            return false
          }
        })
      }
    },
    Verificationa () {
      if (this.shuru.Verification == '') {
        this.cuowuspan.Verification = '请输入验证码'
        this.Verification = true
        return false
      } else if (this.shuru.Verification) {
        var reg = /^\d{6}$/
        if (reg.test(this.shuru.Verification)) {
          this.Verification = false
          this.cuowuspan.Verification = ''
        } else {
          this.Verification = true
          this.cuowuspan.Verification = '验证码格式有误'
          return false
        }
      }
    },
    passa () {
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入密码'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,25}$/
        if (reg.test(this.shuru.pass)) {
          this.cuowuspan.pass = ''
          this.pass = false
        } else {
          this.cuowuspan.pass = '密码格式有误'
          this.pass = true
          return false
        }
      }
    },
    Register () {
      if (this.shuru.phone == '' || this.shuru.Verification == '') {
        return false
      } else if (this.phone == true || this.Verification == true) {
        return false
      } else {
        if (this.password_show == true && this.pass == true) {
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var Invitationq = (this.shuru.invitation).substring(0, 4)
        var Invitationh = (this.shuru.invitation).substring(5, 9)
        this.http.Bindwx(this.shuru.phone, this.shuru.Verification, this.shuru.pass, this.access_token, this.open_id)
          .then(res => {
            if (res.data.code == 200) {
              loading.close()
              this.$message({
                message: '恭喜您！绑定成功',
                type: 'success'
              })
              this.shifou = true
              this.$cookieStore.setCookie('user_sess', res.data.date.token, 2590000)
              this.$router.push('./Home') // 强制切换当前路由 path
            } else if (res.data.code == 400) {
              loading.close()
              this.$message.error(res.data.message)
            }
          })
      }
    }

  },
  created: function () {
    // 邀请码键盘事件
    var that = this
    document.onkeyup = function (e) {
      var key = window.event.keyCode
      if (that.shuru.invitation.length == 4) {
        that.shuru.invitation += '—'
      }
      that.shuru.invitation = that.shuru.invitation.toUpperCase()
    }
    // 判断浏览器的宽度
    if (document.body.clientWidth < 750) {
      this.sceneaa = String('nc_other_h5')
    } else {
      this.sceneaa = String('nc_other')
    }

    var url = window.location.href             // 获取当前url
    var dz_url = url.split('#')[0]                // 获取#/之前的字符串
    var cs = dz_url.split('?')[1]                // 获取?之后的参数字符串
    var cs_arr = cs.split('&')                    // 参数字符串分割为数组
    var cs = {}
    for (var i = 0; i < cs_arr.length; i++) {         // 遍历数组，拿到json对象
      cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
    this.access_token = cs.access_token
    this.open_id = cs.open_id
  },

  beforeDestroy () {
    this.$cookieStore.delCookie('nc_token')
    this.$cookieStore.delCookie('csessionid')
    this.$cookieStore.delCookie('sig')
  }
}
</script>
<style scoped>
.shifou {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}
.shifou .shifoua {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #000;
  opacity: 0.5;
}
.shifou .shifoub {
  padding: 30px;
  width: 300px;
  height: 150px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -105px;
  margin-left: -180px;
}
.upload-demo {
  margin-left: 270px;
  margin-bottom: 20px;
}
#Register {
  background: #f2f2f2;
  padding-bottom: 100px;
}
#Register > img {
  display: block;
  width: 100%;
  height: 200px;
  margin: 0 auto;
}
#Register .header {
  width: 100%;
  height: 60px;
  background: #fff;
  margin-bottom: 60px;
}
#Register .header .logo {
  margin-left: 20px;
  display: block;
  width: 8rem;
  height: 60px;
}
#Register .header .logo img {
  width: 100%;
  height: auto;
  margin-top: 15px;
}
#Register .header .Return {
  width: 90px;
  font-size: 16px;
  height: 32px;
  line-height: 32px;
  margin-top: 13px;
  font-weight: bold;
}
#Register .header .Return:hover {
  color: #295ca4;
}
#Register .header .Return img {
  width: 32px;
  height: 32px;
  vertical-align: bottom;
  margin-right: 5px;
}
#Register .header p {
  width: 100%;
  line-height: 60px;
  text-align: center;
  font-weight: bold;
  font-size: 1.625rem;
  margin-left: -8rem;
}
.signIn {
  width: 37.5rem;
  position: relative;
  margin: 50px auto;
  background: #f2f2f2;
  border: 10px solid #fff;
  padding: 6.25rem;
  border-radius: 10px;
}
.inputm {
  border: 2px solid #dfdfdf;
}
.inputh {
  border: 2px solid #e60012;
  background: #ffe4e4;
}
.signIn .input {
  height: 55px;
  margin-bottom: 20px;
}
.signIn ul {
  width: 300px;
  margin-bottom: 20px;
  margin-left: 290px;
}
.signIn ul li {
  list-style: disc;
  margin-bottom: 10px;
  line-height: 20px;
  font-size: 14px;
}
.signIn .input div {
  position: relative;
}
.signIn .input .fangchenmi {
  width: 18.75rem;
  height: 13px;
  position: absolute;
  top: -14px;
  left: 16.875rem;
  font-size: 0.75rem;
  line-height: 12px;
  z-index: 10;
}
.signIn .input .fangchenmi .why {
  display: block;
  padding: 0.625rem;
  width: 17.5rem;
  height: 80px;
  border: 1px solid #dfdfdf;
  position: absolute;
  top: 14px;
  left: 0;
  color: #3d3d3d;
  background: #fff;
  line-height: 20px;
}

.signIn .input p {
  width: 268px;
  line-height: 55px;
  height: 55px;
  font-size: 0.875rem;
  font-weight: bold;
}
.signIn .input input {
  display: block;
  padding: 6px 0.875rem;
  width: 18.75rem;
  height: 24px;
  border-radius: 5px;
}
.signIn .input span {
  position: absolute;
  top: 40px;
  left: 16.75rem;
  font-size: 0.75rem;
  color: #e60012;
}
.signIn .pic ul {
  margin-bottom: 10px;
}
.signIn .pic li {
  list-style: disc;
  text-align: left;
  line-height: 18px;
}
.signIn .checkboxa {
  overflow: hidden;
  padding: 30px 0;
  border-top: 2px solid #dfdfdf;
  border-bottom: 2px solid #dfdfdf;
}
.signIn .checkboxa input {
  width: 1.25rem;
  height: 20px;
  border: 2px solid #dfdfdf;
  border-radius: 10px;
  margin-right: 0.625rem;
}
.signIn .checkboxa p {
  width: 35rem;
  display: inline-block;
  color: #3c3c39;
  font-size: 1rem;
}
.signIn .checkboxa a {
  font-weight: bold;
}
.Registerbtnm {
  background: #b1b1b1;
}
.Registerbtnl {
  background: #295ca4;
}
.signIn .Registerbtn a {
  width: 6.875rem;
  height: 18px;
  display: block;
  padding: 9px 1.25rem;
  border: 1px solid #b1b1b1;
  border-radius: 19px;
  color: #fff;
  text-align: center;
  margin: 30px auto;
}
.signIn .Registerbtn p {
  text-align: center;
}
.signIndenglu {
  height: 12.5rem;
  margin-top: -15.625rem;
}
.demo-ruleForm .dengLu {
  width: 18.75rem;
  display: flex;
  justify-content: space-around;
  margin-left: 5rem;
}
.demo-ruleForm .dengLu a {
  display: inline-block;
  font-size: 0.75rem;
  margin-top: 20px;
}
/* 为什么要填写身份证号 */
.yanzheng {
  width: 18.75rem;
  height: 1.125rem;
  margin-left: 6.25rem;
  position: relative;
}
.yanzheng p {
  font-size: 0.75rem;
}
.yanzheng .tianxie {
  float: left;
}
.yanzheng .why {
  float: right;
  color: red;
}
.yanzheng .txcont {
  width: 18.75rem;
  position: absolute;
  top: 1.375rem;
  right: 0;
  z-index: 21;
  border: 1px solid #c7c7c7;
  line-height: 20px;
  padding: 0.625rem;
  background: #fff;
}
.yanzheng .txcont img {
  width: 0.8125rem;
  height: 0.5rem;
  position: absolute;
  top: -0.5rem;
  right: 1.5625rem;
}
/* 注册协议 */
#xykjxieyi {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 20;
  background: #fff;
}
#xykjxieyi .xieyi {
  border: 2px solid #999;
  padding: 20px 1.25rem 20px 1.25rem;
  text-align: left;
  width: 37.5rem;
  height: 500px;
  position: absolute;
  top: 3.125rem;
  left: 50%;
  margin-left: -20rem;
  overflow-y: scroll;
}
#xykjxieyi .xieyi .btn {
  width: 12.5rem;
  height: 3.125rem;
  margin: 2.5rem auto;
}
#xykjxieyi .xieyi .btn button {
  width: 9.375rem;
  height: 3.125rem;
  background: #007bff;
  color: #fff;
  font-size: 1.25rem;
}
.wwww {
  width: 9.375rem;
  float: left;
}
.fasong {
  width: 7.5rem;
  float: left;
  height: 1.875rem;
  font-size: 0.875rem;
  padding: 0 0.625rem;
  margin-top: 5px;
  margin-left: 1.25rem;
}
.marglef {
  margin-left: 1.875rem;
}
.mang_anto {
  margin: 0 auto;
}
.disblk {
  display: block;
}
.huakuai {
  margin-left: 6.25rem;
}
@media screen and (max-width: 750px) {
  .upload-demo {
    margin-left: 0;
  }
  #Register {
    width: 100%;
  }
  .signIn {
    width: 300px;
    padding: 5px;
    border: 5px solid #fff;
  }
  #Register .header .logo {
    display: block;
    width: 8rem;
    height: 60px;
    /* background: #e60012; */
  }
  #Register .header p {
    display: none;
  }
  #Register .header .Return {
    width: 5.625rem;
    font-size: 1rem;
    height: 2rem;
    line-height: 2rem;
    margin-top: 17px;
    font-weight: bold;
  }
  #Register .header .Return span {
    display: block;
    height: 2rem;
  }
  #Register .header .Return:hover {
    color: #295ca4;
  }
  #Register .header .Return img {
    width: 2rem;
    height: 2rem;
    vertical-align: bottom;
    margin-right: 5px;
  }
  .signIn .input {
    height: 95px;
  }
  .signIn .input input {
    width: 275px;
  }
  .signIn .input span {
    position: absolute;
    top: 95px;
    left: 0;
    font-size: 0.75rem;
    color: #e60012;
  }
  .from {
    width: 300px;
    margin: 0;
  }
  .signIn .checkboxa p {
    width: 270px;
  }
  .signIn .checkboxa {
    width: 300px;
    /* margin-top: 200px; */
  }
  .signIn .input .fangchenmi {
    /* width: 18.75rem; */
    position: absolute;
    top: 40px;
    left: 0;
  }
  .signIn ul {
    width: 300px;
    margin-bottom: 20px;
    margin-left: 0;
  }
  /* 协议 */
  #xykjxieyi .xieyi {
    border: 2px solid #999;
    padding: 20px 1.25rem 20px 1.25rem;
    text-align: left;
    width: 300px;
    height: 400px;
    position: absolute;
    top: 3.125rem;
    left: 50%;
    margin-left: -167px;
    overflow-y: scroll;
  }
  #xykjxieyi .xieyi .btn {
    width: 12.5rem;
    height: 3.125rem;
    margin: 2.5rem auto;
  }
  #xykjxieyi .xieyi .btn button {
    width: 9.375rem;
    height: 3.125rem;
    background: #007bff;
    color: #fff;
    font-size: 1.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BindWx.vue